import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { festivalActions } from '../../../redux/actions/festival-action';
import ReactTable from "react-table";

import 'react-table/react-table.css';
import {
  Grid,
  Row,
  Col,
  Tooltip,
  OverlayTrigger
} from "react-bootstrap";

import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";

class FestivalAdjudicatorAllListPage extends React.Component {
  constructor(props){
    super(props);
      let AdminUserStorage = JSON.parse(localStorage.getItem('admin-user'));
      // console.log('AdminUserStorage', AdminUserStorage);
      this.state = {
          sorted    :'',
          filtered  :'',
          companyId :this.props.userAdmin.user.company_id,
          AdminUserStorageToken : AdminUserStorage.token
      };
      this.festivalPaginationData  = this.festivalPaginationData.bind(this);
      this.filterSearchHandle     = this.filterSearchHandle.bind(this);
  }


  filterSearchHandle(e){
      this.setState({
          'filtered': e.target.value
      });
  }
  
  festivalPaginationData(page, filter, sort, pageSize){
    this.props.getFestivalAllAdjudicatorsCall(page, filter, sort, this.state.companyId, pageSize);
  }
  
  render(){
        const { festivalAllAdjudicatorsData,festivalAllAdjudicatorsPages,loading, adminType,userAdmin  } = this.props;
        const { filtered } = this.state;
        const columns = [
            {
                Header:"Festival Adjudicators Listing",
                columns: [
                    {
                        Header: "First Name",
                        accessor: "first_name",
                        className: "action-center"
                        
                    },
                    {
                        Header: "Last Name",
                        accessor: "last_name",
                        className: "action-center"
                    },
                    {
                        Header: "Email",
                        accessor: "email",
                        className: "action-center"
                        
                    },
                    {
                        Header: "Adjudicator Code",
                        accessor: "adjudicator_code",
                        className: "action-center"
                    },
                    {
                        Header: "Festival",
                        accessor: "festival",
                        className: "action-center",
                        Cell : ({value}) => (
                          <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Festival {adminType ==='company'?'edit':'view'}</Tooltip>}>
                            <Link to={'/Admin/Edit-Festival/'+value.id} >{value.name}</Link>
                          </OverlayTrigger>
                        )
                    },
                    {
                      Header: "Actions",
                      accessor: "festival",
                      Cell: ({value}) => (
                        <div>
                          <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Adjudicators</Tooltip>}>
                            <Link to={'/Admin/Festival/'+value.id+'/Music-directors'} className="action-button-size"><i className="fa fa-users " /></Link>
                          </OverlayTrigger>
                          
                        </div>
                      ),
                      className: "action-center",
                      sortable:false,
                      show:false
                  }
                ]
            }
        ];
    return(
            <div className="content">
                <Grid fluid>
                  <Row>
                    <Col md={12}>
                      <Card
                        title="Festivals Adjudicators List"
                        ctTableResponsive
                        content={
                          <div>
                            <Grid fluid>
                                <Row>
                                  
                                    <Col md={8}>
                                      
                                    </Col>
                                  
                                    
                                    <Col md={4} sm={6} xs={12}>
                                      <div >
                                        <FormInputs
                                          ncols={["col-md-12"]}
                                          onChange={this.filterSearchHandle}
                                          proprieties={[
                                            {
                                              type: "text",
                                              bsClass: "form-control",
                                              placeholder: "Seach Festival Adjudicators",
                                              onChange:this.filterSearchHandle,
                                              name:"filter"
                                            }

                                          ]}
                                        />
                                      </div>
                                    </Col>
                                </Row>
                            </Grid>
                            {
                              adminType && userAdmin && 
                              <ReactTable
                                  
                                  data={festivalAllAdjudicatorsData}
                                  pages={festivalAllAdjudicatorsPages} 
                                  loading = {loading}
                                  columns={columns}
                                  filtered={filtered}
                                  defaultPageSize={10}
                                  className="striped hover"
                                  pageData = {this.festivalPaginationData}
                                  manual
                                  onFetchData={(state, instance) => {
                                      var sort = state.sorted.length === 0 ? '' : state.sorted[0].id+',desc:'+state.sorted[0].desc;
                                      state.pageData(state.page+1, state.filtered, sort, state.pageSize);
                                  }}
                              />
                            }
                            
                          </div>
                        }
                      />
                    </Col>
                  </Row>
                </Grid>
            </div>
      
    );
  };
}

const mapDispatchToProps = dispatch => {
  return ({
    getFestivalAllAdjudicatorsCall  : (page, filter, sort, companyId, pageSize) => { dispatch(festivalActions.getFestivalsAllAdjudicatorsPagination(page, filter, sort, companyId, pageSize)) },
  });
};

function mapStateToProps(state) {
    const { festivalAllAdjudicatorsData,festivalAllAdjudicatorsPages,loading } = state.festivalReducer;
    const { adminType, userAdmin } = state.adminReducer;
    return {
        festivalAllAdjudicatorsData,festivalAllAdjudicatorsPages,loading,adminType, userAdmin
    };
}

const FestivalAdjudicatorAllList = connect(mapStateToProps, mapDispatchToProps)(FestivalAdjudicatorAllListPage);

export default FestivalAdjudicatorAllList;


// WEBPACK FOOTER //
// ./src/components/Admin/FestivalAdjudicator/FestivalAdjudicatorAllList.jsx